export const MAIN_LOADER_EVENT = 'app-event-loader-toggle-view';

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/components/ui/p-main-loader.constants.js